import React, { useContext } from 'react';
import StarRating from '../StarRating/StarRating';
import styles from './styles.css';
import { formatDate } from '../../flows/shared/dateUtils';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import SFMethodologyModal from '../SelectFundsMethodology/SFMethodologyModal';
import { FlowContext } from '../../core/flow-engine';
import { modalOpenHandler } from '../Modal/utils';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const FundNameSection = ({
  name,
  ticker,
  morningStarRatings,
  isMoneyMarketView = false
}) => {
  const { next } = useContext(FlowContext);
  const fundResearchLink = `https://www.troweprice.com/personal-investing/tools/fund-research/${ticker}`;
  const asOfDate = morningStarRatings?.asOfDate || new Date();

  return (
    <div className="fund-name-section">
      <div className="header-text">Fund Name</div>
      <hr />
      <h1 className="fund-name">
        {name} ({ticker})
      </h1>
      {isMoneyMarketView ? (
        <div className="money-market-disclaimer">
          <p>
            The T. Rowe Price U.S. Treasury Money Fund is one of the T. Rowe
            Price(R) Select Funds.{' '}
            <span className="sf-methodolgy-btn">
              <MFBeaconButton
                id="reviewSFMethodologyBtn"
                data-name={generateGeneralTestID(
                  'MoneyMarket',
                  'SelectFundsMethodologyButton'
                )}
                type="button"
                onClick={() => modalOpenHandler('sfMethodologyModal')}
                variant="tertiary"
                className="override-beacon-button-padding"
                label="Review our Select Funds Methodology."
              />
            </span>{' '}
            This fund invests in U.S. Treasury securities and other securities
            backed by the full faith and credit of the U.S. government.
          </p>
          <p>
            If you&apos;d like to view other types of money market funds,
            including funds that seek to provide tax-free income by investing
            primarily in municipal money market securities,{' '}
            <span className="money-market-funds-btn">
              <MFBeaconButton
                type="button"
                id="viewAllMoneyMarket"
                data-name={generateGeneralTestID(
                  'MoneyMarket',
                  'ViewAllMoneyMarketButton'
                )}
                onClick={next('viewAllMoneyMarketFunds')}
                variant="tertiary"
                className="override-beacon-button-padding"
                label="view all Money Market Funds."
              />
            </span>
          </p>
        </div>
      ) : (
        morningStarRatings?.morningStarOverallRating !== 0 && (
          <div className="morningStarRating">
            <div className="fund-rating-info">
              <div>
                <a
                  target="_blank"
                  href={fundResearchLink}
                  rel="noopener noreferrer">
                  Overall Morningstar Rating<sup>TM</sup>
                </a>
              </div>
              <div className="star-rating">
                <StarRating
                  rating={morningStarRatings?.morningStarOverallRating}
                />
              </div>
            </div>
            <div className="breather">
              (out of {morningStarRatings?.morningStarOverallQuantity}{' '}
              {morningStarRatings?.morningStarCategoryName} funds as of{' '}
              {formatDate(asOfDate, 'MM/DD/YYYY')}*)
            </div>
            <div className="breather">
              Morningstar Ratings<sup>TM</sup> are based on risk-adjusted
              returns. Click on &quot;Overall Rating&quot; for the fund&apos;s
              3-, 5-, and 10-year (if applicable) Morningstar Ratings™.
            </div>
          </div>
        )
      )}
      <style jsx>{styles}</style>
      <SFMethodologyModal />
    </div>
  );
};

export default FundNameSection;
